module.exports = __webpack_public_path__ + "media/images/Grubspotr-SpotrOS Logoo-2c78a9c22dc7026642f86fcb96c78f95.png";